import styled from "styled-components"

export const ConfigWrapper = styled.div`
  cursor: pointer;
`
